import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { Subject } from 'rxjs';
import { ConstantValues } from '../models/util/constantValues';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ErrorLevel } from '../models/enums';
import { ICustomNotification } from '../models/notification/customNotification';

@Injectable()
export class UserActivityService{
  private timer: any;
  private stopAllComunicationSource = new Subject();
  stopAllComunication$ = this.stopAllComunicationSource.asObservable();

  constructor(private notificationService: NotificationService) {
    window.addEventListener('mousedown', () => this.resetTimer());
    window.addEventListener('click', () => this.resetTimer());
    window.addEventListener('keypress', () => this.resetTimer());
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.logout(), ConstantValues.MAX_INACTIVITY_MIN * 60 * 1000);
  }

  stopAllComunication() {
    this.stopAllComunicationSource.next();
  }

  logout(): void {
    const error: ICustomNotification = {
    title : DynamicTranslations.notification_title,
    message : DynamicTranslations.notification_inactivity_ErrorMessage,
    errorLevel : ErrorLevel.Notification,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(error);
    this.stopAllComunicationSource.next();
  }
}
